import Product from '@/modules/common/common/models/DXP/Product'

export default class GetProductResponse {
  product: Product

  constructor(data: any) {
    this.product = new Product(data.product)
  }
}
